import { render, staticRenderFns } from "./selectAvatarViewer.vue?vue&type=template&id=2b92a99c"
import script from "./selectAvatarViewer.vue?vue&type=script&lang=js"
export * from "./selectAvatarViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports